const getSelectedResources = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const allResources = document.getElementById('select_all')?.value === 'true'
  const resourceIds = Array.from(document.querySelectorAll('td.resource-checkbox-column input:checked'))
    .map(checkbox => checkbox.id)
    .filter(id => id !== 'select_page')

  return {
    allResources: resourceIds.length === 0 ? true : allResources,
    resourceIds: allResources ? [] : resourceIds,
    query: searchParams.get('q'),
    resourceStatus: searchParams.get('resource_status'),
    startDate: searchParams.get('start_date'),
    endDate: searchParams.get('end_date')
  }
}

const submitExportForm = ({
  url,
  format,
  sectionIds = [],
  questionIds = [],
  withVariables = true,
  exportAsZip = true,
  ignoreFilters = false,
  selectionParam = 'resource_ids'
}) => {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = url

  // Add CSRF token
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  if (csrfToken) {
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)
  }

  const payload = getSelectedResources()
  const formPayload = {
    // eslint-disable-next-line camelcase
    all_resources: payload.allResources,
    [selectionParam]: payload.resourceIds.join(','),
    // eslint-disable-next-line camelcase
    ignore_filters: ignoreFilters ? 'true' : null,
    // eslint-disable-next-line camelcase
    start_date: payload.startDate,
    // eslint-disable-next-line camelcase
    end_date: payload.endDate
  }

  Object.entries(formPayload).forEach(([key, value]) => {
    if (value) {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      input.value = value
      form.appendChild(input)
    }
  })

  if (!ignoreFilters) {
    [
      { name: 'q', value: payload.query },
      { name: 'resource_status', value: payload.resourceStatus }
    ].filter(({ value }) => value).forEach(({ name, value }) => {
      const filterInput = document.createElement('input')
      filterInput.type = 'hidden'
      filterInput.name = name
      filterInput.value = value
      form.appendChild(filterInput)
    })
  }

  if (sectionIds.length > 0) {
    const sectionsInput = document.createElement('input')
    sectionsInput.type = 'hidden'
    sectionsInput.name = 'section_ids'
    sectionsInput.value = sectionIds.join(',')
    form.appendChild(sectionsInput)
  }

  if (questionIds.length > 0) {
    const questionsInput = document.createElement('input')
    questionsInput.type = 'hidden'
    questionsInput.name = 'question_ids'
    questionsInput.value = questionIds.map(question => question.id).join(',')
    form.appendChild(questionsInput)
  }

  if (sectionIds.length > 0 || questionIds.length > 0) {
    const variablesInput = document.createElement('input')
    variablesInput.type = 'hidden'
    variablesInput.name = format === 'xlsx' ? 'variable_ids' : 'all_variables'
    variablesInput.value = format === 'xlsx' ? '[]' : withVariables
    form.appendChild(variablesInput)
  }

  if (format === 'pdf') {
    const exportAsZipInput = document.createElement('input')
    exportAsZipInput.type = 'hidden'
    exportAsZipInput.name = 'export_as_zip'
    exportAsZipInput.value = exportAsZip
    form.appendChild(exportAsZipInput)
  }

  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

export const getResourcesFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search)

  return {
    resourceIds: searchParams.get('resource_ids')?.split(',') || [],
    answerIds: searchParams.get('answer_ids')?.split(',') || [],
    allResources: searchParams.get('all_resources') === 'true',
    query: searchParams.get('q'),
    resourceStatus: searchParams.get('resource_status'),
    startDate: searchParams.get('start_date'),
    endDate: searchParams.get('end_date')
  }
}

export const splitSelection = selectedQuestions => ({
  sectionIds: Object.entries(selectedQuestions)
    .filter(([, questions]) => questions.length > 0)
    .map(([sectionId]) => sectionId),
  questionIds: Object.values(selectedQuestions).flat()
})

export const resourceFilterInputs = selectedResources => {
  const inputs = []

  if (selectedResources.resourceIds?.length > 0)
    inputs.push({ name: 'resource_ids', value: selectedResources.resourceIds.join(',') })

  if (selectedResources.answerIds?.length > 0)
    inputs.push({ name: 'answer_ids', value: selectedResources.answerIds.join(',') })

  if (selectedResources.allResources)
    inputs.push({ name: 'all_resources', value: 'true' })

  if (selectedResources.query)
    inputs.push({ name: 'q', value: selectedResources.query })

  if (selectedResources.resourceStatus)
    inputs.push({ name: 'resource_status', value: selectedResources.resourceStatus })

  if (selectedResources.startDate)
    inputs.push({ name: 'start_date', value: selectedResources.startDate })

  if (selectedResources.endDate)
    inputs.push({ name: 'end_date', value: selectedResources.endDate })

  return inputs
}

export const appendHiddenInputs = (form, inputs) => {
  inputs.forEach(({ name, value }) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  })
}

export const addFormInputs = (form, data) => {
  Object.entries(data).forEach(([key, value]) => {
    if (value === null)
      return

    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = key

    if (Array.isArray(value))
      input.value = value.join(',')
    else if (typeof value === 'boolean')
      input.value = value.toString()
    else
      input.value = value


    form.appendChild(input)
  })
}

export const singlePdfLimitMessage = (count, max, unit) => {
  if (count === null || max === null || count <= max)
    return null

  return `Au-delà de ${max} ${unit}, l'export en un seul PDF n'est pas disponible.`
}

export const getAuthToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.content

export const getQueryParam = name =>
  new URLSearchParams(window.location.search).get(name)

export const getDateRangeParams = () => Object.fromEntries(
  ['start_date', 'end_date'].map(key => [key, getQueryParam(key)])
)

export {
  getSelectedResources,
  submitExportForm

}